import _ from 'lodash'

const DEFAULT_COLUMNS = [
  { key: 'photo_thumb', default: '', name: 'Bilde', sortKey: '', class: 'c-image unsortable', readonly: true, selected: true },
  // { key: 'Objektid', default: '', name: 'Objektid', sortKey: 'Objektid', class: 'sorttable_numeric', readonly: true },
  { key: 'Objektnr', default: '', name: 'Objektnr', sortKey: 'Objektnr', class: 'sorttable_numeric', readonly: true, selected: true },
  { key: 'Kategori', default: '-', name: 'Kat.', sortKey: 'Kategori', class: '', selected: true },
  { key: 'Registrert_dato', default: '-', name: 'Registrert', sortKey: 'Registrert_dato', class: 'sorttable_numeric', filter: 'datetime', selected: true },
  { key: 'avdeling.Beskrivelse', default: '-', name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: '', selected: true },
  { key: 'Objekttype', default: '-', name: 'Type', sortKey: 'Objekttype', class: '', selected: true },
  { key: 'Auksjon', default: '-', name: 'Auksjon', sortKey: 'Auksjon', class: '', selected: true },
  { key: 'Katalognr', default: '', name: 'Kat.nr', sortKey: 'Katalognr', class: 'sorttable_numeric', selected: true },
  { key: 'Katalogtekst1', default: '-', name: 'Tittel', sortKey: 'Katalogtekst1_trimmed', class: 'nowrap', tooltip: true, selected: true },
  { key: 'Objekt3', default: '-', name: 'Beskrivelse', sortKey: 'Objekt3.sort', class: 'nowrap', tooltip: true, selected: true },
  { key: 'kunstner.Navn', default: '-', name: 'Kunstner', sortKey: 'kunstner.Navn.sort', class: '', selected: true },
  { key: 'auksjonsdato', default: '-', name: 'Auksjonsdato', sortKey: 'auksjonsdato', class: '', filter: 'date', selected: true },
  { key: 'Katalogtekst2', default: '-', name: 'Tekst', sortKey: 'Katalogtekst2.sort', class: 'nowrap', tooltip: true, selected: true },
  { key: 'Salgspris', default: '-', name: 'Tilslag', sortKey: 'salgspris_sort', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderingspris1', default: '-', name: 'Høy', sortKey: 'Vurderingspris1', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Vurderingspris2', default: '-', name: 'Lav', sortKey: 'Vurderingspris2', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Minstepris', default: '-', name: 'Minstepris', sortKey: 'Minstepris', class: 'align-left', filter: 'integer', selected: true },
  { key: 'Objekt1', default: '-', name: 'Signert', sortKey: 'Objekt1.sort', class: 'nowrap', tooltip: true, selected: true },
  { key: 'lokasjon.Lokasjonkode', default: '-', name: 'Lokasjon', sortKey: 'lokasjon.Lokasjonkode', class: '', selected: true },
  { key: 'Lev_dato', default: '-', name: 'Hentet', sortKey: 'Lev_dato', class: '', filter: 'date', selected: true },
  { key: 'Tekst_ok', default: '', name: 'Objekt', sortKey: 'Tekst_ok', class: '', selected: true },
  { key: 'Fototatt', default: '', name: 'Foto', sortKey: 'Fototatt', class: '', selected: true },
  { key: 'Bet_dato', default: '-', name: 'Betalt', sortKey: 'Bet_dato', class: '', filter: 'date', selected: true },
  { key: 'Lev_dato', default: '-', name: 'Utlevert', sortKey: 'Lev_dato', class: '', filter: 'date', selected: true },
  { key: 'Fakturert', default: '', name: 'Fakturert', sortKey: 'Fakturert', class: '', selected: true },
  { key: 'oppgjor_dato', default: '-', name: 'Oppgjørsdato', sortKey: 'oppgjor_dato', class: 'sorttable_numeric', filter: 'datetime', selected: true },
  { key: 'oppgjor_belop', default: '-', name: 'Oppgjørsbelop', sortKey: 'oppgjor_belop', class: 'sorttable_numeric', filter: 'decimal', selected: true },
  { key: 'kontraktsansvarlig.Brukernavn', default: '-', name: 'Kontraktsansvarlig', sortKey: 'kontraktsansvarlig.Brukernavn', class: '', selected: true },
  { key: 'mottaker.Kundenr', default: '-', name: 'Kjøper #', sortKey: 'mottaker.Kundenr', class: '', selected: false },
  { key: 'mottaker.full_name', default: '-', name: 'Kjøper', sortKey: 'mottaker.full_name', class: '', selected: true },
  { key: 'innlevav.Kundenr', default: '-', name: 'Selger #', sortKey: 'innlevav.Kundenr', class: '', selected: false },
  { key: 'innlevav.full_name', default: '-', name: 'Selger', sortKey: 'innlevav.full_name', class: '', selected: true }
]

const DEFAULT_IMAGE_SIZES = [
  { key: 'c-image-none', name: 'Ingen bilder', selected: false },
  { key: 'c-image-small', name: 'Små bilder', selected: true },
  { key: 'c-image-medium', name: 'Mellomstore bilder', selected: false },
  { key: 'c-image-large', name: 'Store bilder', selected: false }
]

const DEFAULT_FILTERS = {
  kategori: [],
  auksjon: [],
  kunstner: [],
  objekttype: null,
  auksjonSearchAll: 0,
  avdeling: [],
  lokasjon: [],
  regdato: {},
  price: {}
}

const LS_KEY = 'object-search-values'
const LS_KEY_COLS = 'columns'
const LS_KEY_QUERY = 'query'
const LS_KEY_FILTERS = 'filters'
const LS_KEY_IMAGE_SIZES = 'imagesizes'

const state = {
  defaultColumns: null,
  defaultImageSizes: null,
  defaultFilters: null,
  defaultQuery: null
}

const loadLs = (key = null) => {
  try {
    const retval = JSON.parse(localStorage.getItem(LS_KEY) || {})

    if (key === null) {
      return retval
    }

    if (!retval.hasOwnProperty(key)) {
      return null
    }

    if (key === LS_KEY_FILTERS) {
      if (!Array.isArray(retval[key].kunstner)) {
        retval[key].kunstner = []
      }

      if (retval[key].regdato.from) {
        retval[key].regdato.from = new Date(retval[key].regdato.from)
      }

      if (retval[key].regdato.to) {
        retval[key].regdato.to = new Date(retval[key].regdato.to)
      }

      if (!retval[key].hasOwnProperty('lokasjon') || !Array.isArray(retval[key].lokasjon)) {
        retval[key].lokasjon = []
      }
    }

    return retval[key]
  } catch (e) {
    return null
  }
}

const saveLs = (key, data) => {
  try {
    const stored = loadLs() || {}
    stored[key] = data
    localStorage.setItem(LS_KEY, JSON.stringify(stored))
  } catch (e) {
    // Ignore
  }
}

const getters = {
  query: state => {
    if (state.defaultQuery === null) {
      let query = loadLs(LS_KEY_QUERY) || ''

      return query
    }

    return state.defaultQuery
  },
  filters: state => {
    if (!state.defaultFilters) {
      let filters = loadLs(LS_KEY_FILTERS) || DEFAULT_FILTERS

      return filters
    }

    return state.defaultFilters
  },
  filterCount: (state, getters) => {
    let count = 0

    Object.keys(getters.filters).forEach(key => {
      const element = getters.filters[key]

      if (key === 'regdato') {
        if (element.from || element.to) {
          ++count
        }
      } else if (!_.isEmpty(element)) {
        ++count
      }
    })

    return count
  },
  columns: state => {
    if (!state.defaultColumns) {
      let retval = loadLs(LS_KEY_COLS) || DEFAULT_COLUMNS

      // How we get possibly new cols added...
      if (retval !== DEFAULT_COLUMNS) {
        retval = _.uniqBy([...retval, ...DEFAULT_COLUMNS], 'key')
      }

      return retval
    }

    return state.defaultColumns
  },
  imagesizes: state => {
    if (!state.defaultImageSizes) {
      return loadLs(LS_KEY_IMAGE_SIZES) || DEFAULT_IMAGE_SIZES
    }

    return state.defaultImageSizes
  },
  selectedImageSize: (state, getters) => {
    return getters.imagesizes.find(i => i.selected === true)
  }
}

const actions = {
  saveImageSizes: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveImageSizes', payload)
      resolve()
    })
  },
  saveColumns: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveColumns', payload)
      resolve()
    })
  },
  resetColumns: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit('resetColumns')
      resolve()
    })
  },
  saveQuery: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveQuery', payload)
      resolve()
    })
  },
  saveSearch: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      commit('saveSearch', payload)
      resolve()
    })
  },
  resetSearch: ({commit, dispatch}, all) => {
    return new Promise((resolve, reject) => {
      commit('resetSearch', all)
      resolve()
    })
  }
}

const mutations = {
  'saveImageSizes': (state, payload) => {
    state.defaultImageSizes = payload
    saveLs(LS_KEY_IMAGE_SIZES, payload)
  },
  'saveColumns': (state, payload) => {
    state.defaultColumns = payload
    saveLs(LS_KEY_COLS, payload)
  },
  'resetColumns': (state) => {
    state.defaultColumns = DEFAULT_COLUMNS
    saveLs(LS_KEY_COLS, DEFAULT_COLUMNS)
  },
  'saveQuery': (state, payload) => {
    state.defaultQuery = payload

    // Save empty query, as we don't want query to be saved anymore...
    saveLs(LS_KEY_QUERY, '')
  },
  'saveSearch': (state, payload) => {
    state.defaultFilters = payload.filters

    // Save only avdeling...
    const save = DEFAULT_FILTERS
    save.avdeling = payload.filters.avdeling || []

    saveLs(LS_KEY_FILTERS, save)

    state.defaultQuery = payload.query

    // And save empty query, as we don't want query to be saved anymore...
    saveLs(LS_KEY_QUERY, '')
  },
  'resetSearch': (state, resetEverything) => {
    if (resetEverything) {
      state.defaultQuery = ''
      saveLs(LS_KEY_QUERY, '')
    }

    state.defaultFilters = DEFAULT_FILTERS
    saveLs(LS_KEY_FILTERS, DEFAULT_FILTERS)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/objectsearch.js